import { render } from "./teams.vue?vue&type=template&id=31361cd8&ts=true"
import script from "./teams.vue?vue&type=script&lang=ts"
export * from "./teams.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__